const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar11015(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64.654 14.951 H 25.345 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 39.309 c 1.657 0 3 1.343 3 3 S 66.312 14.951 64.654 14.951 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 87 31.837 H 3 c -1.657 0 -3 -1.343 -3 -3 v -8.87 C 0 13.893 4.942 8.951 11.016 8.951 h 6.398 c 1.657 0 3 1.343 3 3 s -1.343 3 -3 3 h -6.398 C 8.25 14.951 6 17.201 6 19.967 v 5.87 h 78 v -5.87 c 0 -2.766 -2.25 -5.017 -5.017 -5.017 h -6.397 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 6.397 C 85.058 8.951 90 13.893 90 19.967 v 8.87 C 90 30.494 88.657 31.837 87 31.837 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.983 89.123 H 11.016 C 4.942 89.123 0 84.181 0 78.106 V 28.837 c 0 -1.657 1.343 -3 3 -3 h 84 c 1.657 0 3 1.343 3 3 v 49.269 C 90 84.181 85.058 89.123 78.983 89.123 z M 6 31.837 v 46.269 c 0 2.767 2.25 5.017 5.016 5.017 h 67.967 c 2.767 0 5.017 -2.25 5.017 -5.017 V 31.837 H 6 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.761 51.483 h -4.762 c -1.442 0 -2.612 -1.169 -2.612 -2.612 v -4.762 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 4.762 c 1.442 0 2.612 1.169 2.612 2.612 v 4.762 C 26.372 50.313 25.203 51.483 23.761 51.483 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.381 51.483 h -4.762 c -1.442 0 -2.612 -1.169 -2.612 -2.612 v -4.762 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 4.762 c 1.442 0 2.612 1.169 2.612 2.612 v 4.762 C 49.993 50.313 48.824 51.483 47.381 51.483 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.001 51.483 h -4.762 c -1.442 0 -2.612 -1.169 -2.612 -2.612 v -4.762 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 4.762 c 1.442 0 2.612 1.169 2.612 2.612 v 4.762 C 73.613 50.313 72.444 51.483 71.001 51.483 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.761 72.022 h -4.762 c -1.442 0 -2.612 -1.169 -2.612 -2.612 v -4.762 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 4.762 c 1.442 0 2.612 1.169 2.612 2.612 v 4.762 C 26.372 70.853 25.203 72.022 23.761 72.022 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.381 72.022 h -4.762 c -1.442 0 -2.612 -1.169 -2.612 -2.612 v -4.762 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 4.762 c 1.442 0 2.612 1.169 2.612 2.612 v 4.762 C 49.993 70.853 48.824 72.022 47.381 72.022 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.001 72.022 h -4.762 c -1.442 0 -2.612 -1.169 -2.612 -2.612 v -4.762 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 4.762 c 1.442 0 2.612 1.169 2.612 2.612 v 4.762 C 73.613 70.853 72.444 72.022 71.001 72.022 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.734 20.025 h -2.708 c -1.442 0 -2.612 -1.169 -2.612 -2.612 V 6.489 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 2.708 c 1.442 0 2.612 1.169 2.612 2.612 v 10.924 C 25.345 18.855 24.176 20.025 22.734 20.025 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.975 20.025 h -2.708 c -1.442 0 -2.612 -1.169 -2.612 -2.612 V 6.489 c 0 -1.442 1.169 -2.612 2.612 -2.612 h 2.708 c 1.442 0 2.612 1.169 2.612 2.612 v 10.924 C 72.586 18.855 71.417 20.025 69.975 20.025 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar11015);
export default __webpack_public_path__ + "static/media/calendar-11015.042038ad18de9641d5e2bed0c3b1030d.svg";
export { ForwardRef as ReactComponent };